/**
 * Hook pour protéger une modal de saisie contre les refetch Realtime.
 *
 * Usage : ajouter `useModalProtection(isOpen)` en début de composant modal.
 * Quand isOpen = true, les invalidations Realtime sont mises en file d'attente.
 * Quand isOpen repasse à false, les invalidations en attente s'exécutent.
 */

import { useEffect } from 'react';
import { registerModalOpen, registerModalClose } from '@/lib/modalProtection';

export function useModalProtection(isOpen: boolean) {
  useEffect(() => {
    if (isOpen) {
      registerModalOpen();
      return () => registerModalClose();
    }
  }, [isOpen]);
}
